export enum PATH_TYPE {
  'DELIVERY' = 'DELIVERY',
  'SWAP' = 'SWAP',
  'MEAL' = 'MEAL',
  'AUTH' = 'AUTH',
  'PROGRESS' = 'PROGRESS',
  'UNKNOWN' = 'UNKNOWN'
}